import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/hooks/useAuth';
import { supabase } from '@/integrations/supabase/client';

export const useLanguageSync = () => {
  const { i18n } = useTranslation();
  const { user } = useAuth();

  useEffect(() => {
    const loadUserLanguagePreference = async () => {
      if (!user) return;

      try {
        const { data: profile, error } = await supabase
          .from('profiles')
          .select('preferred_language')
          .eq('user_id', user.id)
          .single();

        if (error) {
          console.warn('Failed to load user language preference:', error);
          return;
        }

        if (profile?.preferred_language && profile.preferred_language !== i18n.language) {
          await i18n.changeLanguage(profile.preferred_language);
        }
      } catch (error) {
        console.warn('Error loading user language preference:', error);
      }
    };

    loadUserLanguagePreference();
  }, [user, i18n]);

  return null;
};